import { getVisitorInfo } from 'src/shared/api/visitor-info'

export const VISITOR_COUNTRY_TIMEOUT_MS = 1500

let visitorCountryPromise: Promise<string | null> | undefined

export const fetchVisitorCountryFromApi = (): Promise<string | null> =>
  getVisitorInfo().then(
    r => (r.data.country?.toLowerCase() as string | undefined) ?? null,
  )

export const prefetchVisitorCountry = (): Promise<string | null> => {
  if (!visitorCountryPromise) {
    const promise = fetchVisitorCountryFromApi().catch(() => {
      if (visitorCountryPromise === promise) {
        visitorCountryPromise = undefined
      }

      return null
    })

    visitorCountryPromise = promise
  }

  return visitorCountryPromise
}

export const getVisitorCountryWithTimeout = (): Promise<string | null> => {
  const current = prefetchVisitorCountry()
  let timer: ReturnType<typeof setTimeout> | undefined

  return Promise.race([
    current.then(result => {
      clearTimeout(timer)
      return result
    }),
    new Promise<null>(resolve => {
      timer = setTimeout(() => {
        if (visitorCountryPromise === current) {
          visitorCountryPromise = undefined
        }

        resolve(null)
      }, VISITOR_COUNTRY_TIMEOUT_MS)
    }),
  ])
}

export const resetVisitorCountryCache = (): void => {
  visitorCountryPromise = undefined
}
